import React, { useState } from "react";
import styled from "styled-components";
import { BsCircle, BsCircleFill } from "react-icons/bs";
import Cursor from "../components/cursor";
import { HiOutlineArrowRight } from "react-icons/hi";
import SanityImage from "gatsby-plugin-sanity-image";
import { useSwipeable } from "react-swipeable";
import Img from "gatsby-image";

const SliderWrapper = styled.div`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  border-radius: ${(props) => props.borderRadius || "0"};

  position: relative;
  background: ${(props) => props.background};

  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: ${(props) => props.fit || "cover"};
  }

  div {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .preload {
    display: none;
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const EmptyState = styled.div`
  background: black;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  border-radius: ${(props) => props.borderRadius || "0"};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const Indicators = styled.ul`
  position: absolute;
  bottom: 0.2rem;
  width: 100%;
  display: flex;
  justify-content: center;

  overflow: visible;
  color: black;
  li {
    margin: 0.2rem;
    cursor: pointer;
    overflow: visible;
    svg {
      width: 0.6rem;
      overflow: visible;
    }
  }
`;

const ChildrenWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

const ImageSlider = ({
  borderRadius,
  width,
  height,
  images,
  children,
  imageWidth,
  useGatsbyImage,
  bg,
  fit,
}) => {
  const [index, setIndex] = useState(0);
  const max = images.length;
  const handleClick = () => {
    let newIndex = (index + 1) % max;
    setIndex(newIndex);
  };

  const goLeft = () => {
    let newIndex = index - 1;
    if (newIndex === -1) {
      newIndex = max - 1;
    }
    setIndex(newIndex);
  };

  const { background, foreground } = images[
    index
  ].asset.metadata.palette.dominant;

  const swipeHandlers = useSwipeable({
    onSwipedRight: () => goLeft(),
    onSwipedLeft: () => handleClick(),
  });

  if (images.length === 0) {
    return (
      <EmptyState borderRadius={borderRadius} width={width} height={height}>
        No Images
      </EmptyState>
    );
  }

  return (
    <SliderWrapper
      max={max}
      borderRadius={borderRadius}
      width={width}
      height={height}
      background={bg || background || "black"}
      fit={fit}
      {...swipeHandlers}
    >
      <Cursor Icon={HiOutlineArrowRight} disabled={max < 2}>
        <ChildrenWrapper>{children}</ChildrenWrapper>
        <ImageWrapper onClick={handleClick}>
          {useGatsbyImage ? (
            <>
              <Img
                key={index}
                fluid={images[index].asset.fluid}
                alt={images[index].alt}
              />
              <div className="preload">
                <Img
                  key={(index + 1) % max}
                  fluid={images[(index + 1) % max].asset.fluid}
                  alt={images[(index + 1) % max].alt}
                />
              </div>
            </>
          ) : (
            <>
              <SanityImage
                {...images[index]}
                width={imageWidth || 800}
                alt={images[index].alt}
              />
              <div className="preload">
                <Img
                  key={(index + 1) % max}
                  fluid={images[(index + 1) % max].asset.fluid}
                  alt={images[(index + 1) % max].alt}
                />
              </div>
            </>
          )}
        </ImageWrapper>

        {max > 1 && (
          <Indicators color={foreground || "black"}>
            {images.map((obj, i) => (
              <li key={i} onClick={() => setIndex(i)}>
                {" "}
                {index === i ? <BsCircleFill /> : <BsCircle />}{" "}
              </li>
            ))}
          </Indicators>
        )}
      </Cursor>
    </SliderWrapper>
  );
};

export default ImageSlider;
